const types = {
  GET_SELECTED_WORKFLOW_SUCCESS: '@drivex/workflows/GET_SELECTED_WORKFLOW_SUCCESS',
};

export { types };
